var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container px--0"},[(_vm.loading || _vm.totalCount)?_c('div',{staticClass:"tour-list"},[_c('Sidebar'),_c('Result')],1):_c('NoResult')],1)}
var staticRenderFns = []

export { render, staticRenderFns }